import { render, staticRenderFns } from "./newsClass.vue?vue&type=template&id=4f51a5e1"
import script from "./newsClass.vue?vue&type=script&lang=js"
export * from "./newsClass.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports